import styled from "styled-components";

export const SelectorFormDiv = styled.div`
  border-radius: 10px;
  box-shadow: ${({ boxShadow }) =>
    boxShadow ? "0px 3px 6px var(--box-shadow)" : ""};
  padding: ${({ boxShadow }) => (boxShadow ? "10px 15px" : "")};
  h5 {
    font-family: "Nunito Bold";
    color: var(--blue-dark-color);
  }
  .date-selector {
    &-title {
      color: var(--blue-dark-color);
      font-size: 10px;
      font-family: "Nunito Sans ExtraBold";
      margin-bottom: 5px;
    }
  }
`;

export const SelectorForm = styled.div`
  z-index: 100;
  width: 100%;
  /* padding: 5px 0 10px; */
  .progression-free-survival-form {
    &-input {
      margin-bottom: 5px;
    }
    &-buttons {
      display: flex;
      justify-content: start;
    }
    &-button {
      width: 100px;
    }
  }
`;
